module.exports = __webpack_public_path__ + "static/media/1.bb77b209.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/shoes/1.png
// module id = 57
// module chunks = 0